/**
 * WordPress Dependencies
 */
import { useBlockProps } from '@wordpress/block-editor';

/**
 * External Dependencies
 */
import classNames from 'classnames';

/**
 * Save function
 */
const Save = ({ attributes }) => {
    const { uniqueId, aff_btnSizeType, label, progressmatify } = attributes;

    /**
     * Block Props
     */
    const blockProps = useBlockProps.save({
        className: classNames(uniqueId, aff_btnSizeType)
    });

    return (
        <div {...blockProps}>
            <div className="gbk-pdReview-criteria-warp">
                <div className="gbk-pdReview-bar-item">
                    <div className="gbk-pdReview-bar-content">
                        <span className="gbk-pdReview-bar-title">{label}</span>
                        <span className="gbk-pdReview-bar-percent">{progressmatify}%</span>
                    </div>
                    <div className="gbk-pdReview-bar-progressmatify">
                        <div className="progressmatify-bar">
                            <div className="progressmatify-bar-fill" style={{ width: `${progressmatify}%` }}></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Save;
